<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m0pkdo/tc-custom/9783985316809.jpg" alt="This image is the cover for the book The Story-Book of Science, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Story-Book of Science, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>The wonders of plant and animal life told with rare literary charm by Uncle Paul in conversations with three children. Besides such stories as the ants' subterranean city, the spider's suspension bridge, and the caterpillars' processing, he unlocks the mystery behind thunder and lightning, clouds and rain, the year and its seasons, and volcanoes and earthquakes. Suitable for ages 9 to 12. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean-Henri Fabre
      </h2>
      
      <p class="authorDescription body article">Jean-Henri Casimir Fabre (21 December 1823 – 11 October 1915) was a French naturalist, entomologist, and author known for the lively style of his popular books on the lives of insects.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a6f409a4